import {makeAutoObservable} from "mobx";

export default class IndicateusStore{


    constructor() {
        makeAutoObservable(this);
    }

}